import { createApp } from 'vue'
import App from './components/App.vue'
import router from './router'
import PrimeVue from 'primevue/config'
import VTooltip from 'v-tooltip'
import Tooltip from 'primevue/tooltip'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import print from 'vue3-print-nb'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChartSimple,
  faTruck,
  faBoxOpen,
  faChartLine,
  faGears,
  faAddressBook,
  faPrint,
  faTruckFront,
  faCommentDollar,
  faAngleLeft,
  faAnglesLeft,
  faChevronCircleLeft,
  faChevronCircleRight,
  faAnglesRight,
  faQuestion,
  faTrashCan,
  faPencil,
  faFlag,
  faFileArrowUp,
  faInfoCircle,
  faCaretUp,
  faCaretDown,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faChartSimple,
  faTruck,
  faBoxOpen,
  faChartLine,
  faGears,
  faAddressBook,
  faPrint,
  faCommentDollar,
  faTruckFront,
  faAngleLeft,
  faAnglesLeft,
  faAnglesRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  faQuestion,
  faTrashCan,
  faPencil,
  faFlag,
  faFileArrowUp,
  faInfoCircle,
  faCaretUp,
  faCaretDown,
)

// Capture any and all 401 responses from the API (Unauthenticated)
// and immediately push through the login process
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (401 === error.response.status) {
      window.location = '/login'
    } else {
      return Promise.reject(error)
    }
  }
)

router.beforeEach((to, from, next) => {
  document.title = 'RMS - ' + to.name
  next()
})

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(PrimeVue)
  .use(ToastService)
  .use(ConfirmationService)
  .use(print)
  .use(VTooltip)
  .use(router)
  .directive('tooltip', Tooltip)
  .mount('#vueApp')
